export default __webpack_public_path__ + "static/media/thumbnail.fa1cda42.webp";